<template>
  <transition
    @enter="enter"
    @after-enter="afterEnter"
    enter-class="invisible"
    leave-class="leaving"
    leave-to-class="hidden"
  >
    <div
      v-if="state != 'hidden'"
      :class="`window window--${size} window--${state} overflow-${overflow}`"
    >
      <div :class="`window__container window__container--${state}`" :style="paddingBottom ? 'padding-bottom: 0': ''">
        <div class="window__head" v-if="showHead">
          <div class="d-flex align-items-center">
            <div v-if="iconitem" v-html="iconitem"></div>
            <h2 v-if="title" class="window__head__title mb-0">{{ title }}</h2>
          </div>
          <div class="window__head__info">
            <slot name="head"></slot>
          </div>

          <button type="button" class="window__btn-close" @click="hide">
            <img src="../../../../img/icons/cross.svg" />
          </button>
        </div>

        <div class="window__content">
          <slot
            :show="show"
            :hide="hide"
            :data="data"
            :args="args"
            :dataTargetCreated="dataTargetCreated"
            :dataTargetUpdated="dataTargetUpdated"
            :onClose="args.onClose"
          >
          </slot>
        </div>

        <div class="window__footer">
          <slot
            name="footer"
            :show="show"
            :hide="hide"
            :data="data"
            :args="args"
            :dataTargetCreated="dataTargetCreated"
            :dataTargetUpdated="dataTargetUpdated"
            :onClose="args.onClose"
          >
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Base from "../Base";
import anime from "animejs";
import { isThisMonth } from "date-fns";

export default {
  extends: Base,
  inject: {
    windowId: { default: undefined },
  },
  props: {
    id: {
      type: String,
      default() {
        return this.windowId;
      },
    },
    size: {
      type: String,
      default: "md", // xs = 450, sm = 480, md = 660, lg = 1100
    },
    title: {
      type: String,
    },
    iconitem: {
      type: String,
    },
    initialData: {
      type: Object,
      default() {
        return {};
      },
    },
    overflow: {
      type: String,
      default: "auto",
    },
    showHead: {
      type: Boolean,
      default: true,
    },
    paddingBottom: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: "hidden",
      data: this.initialData,
      resetOnClose: true,
      onClose: null,
      args: {},
    };
  },
  watch: {
    data: function (newData) {
      if (this.$dataTarget) {
        this.$dataTarget.data = newData;
      }
    },
  },
  methods: {
    show(triggerElement = null) {
      this.triggerElement = triggerElement;
      this.state = "visible";

      this.$emit("show", this);
      this.$root.$emit("window.show", this);
    },
    hide(data = undefined, event = undefined) {
      this.state = "hidden";

      if (data instanceof Event) {
        event = data;
        data = undefined;
      }

      if (this.onClose) {
        this.onClose(this, data, event);
      }

      this.$emit("closed", { window: this, result: data, trigger: event });
      this.$root.$emit("window.closed", {
        window: this,
        result: data,
        trigger: event,
      });

      if (this.resetOnClose) {
        this.reset();
      }
    },
    dataTargetCreated(target) {
      this.$dataTarget = target;
    },
    dataTargetUpdated() {
      if (this.$dataTarget) {
        this.data = this.$dataTarget.data;
      }
    },
    enter(el, done) {
      let doc = document.getElementsByTagName("html")[0];

      let targetWidth = el.scrollWidth;
      let targetHeight = el.scrollHeight;
      let targetX = doc.clientWidth / 2 - targetWidth / 2;
      let targetY = doc.clientHeight / 2 - targetHeight / 2;
      targetX = targetX > 0 ? targetX : 0;
      targetY = targetY > 0 ? targetY : 0;

      if (this.args.props.state == "visible") {
        el.style.width = targetWidth + "px";
        el.style.height = "auto";
        el.style.left = targetX + "px";
        el.style.top = targetY + "px";

        done();
      } else {
        if (this.triggerElement) {
          let triggerElementPos = this.triggerElement.getBoundingClientRect();
          el.style.left =
            triggerElementPos.x + triggerElementPos.width / 2 + "px";
          el.style.top =
            this.size == "full"
              ? "0px"
              : triggerElementPos.y + triggerElementPos.height / 2 + "px";
        }

        el.style.width = targetWidth + "px";
        el.style.height = targetHeight + "px";
        el.style.left = targetX + "px";
        el.style.top = targetY + "px";
        el.style.opacity = 0;
        let animationDuration = this.size == "full" ? 350 : 250;

        anime({
          targets: el,
          easing: "linear",
          duration: animationDuration,
          width: targetWidth + "px",
          height: targetHeight + "px",
          left: targetX + "px",
          top: targetY + "px",
          complete: (anim) => {
            el.style.opacity = 1;
            if (targetHeight < doc.clientHeight - 5) {
              el.style.height = "auto";
            }
            done();
          },
        });
      }
    },
    afterEnter(el) {
      this.$emit("opened", this);
      this.$root.$emit("window.opened", this);
    },
  },
};
</script>

<style lang="scss">
.window {
  display: flex;
  flex-direction: column;

  &__container {
    min-width: 100%;

    &--loading {
      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.7);
      }
    }
  }
}
</style>  